export const JobTypes = [
    {name:'Main Job',value:'Main Job'},{name : 'Sub Job',value:'Sub Job'}
]